
import { CARRIER } from '../util/constants'

export default {
  data() {
    return{
      CARRIER
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    subscription() {
      return this.$store.state.payment.subscription;
    },
  },
  methods: {
    redirectToSubscription(){
      this.$router.push({
        path: '/settings/subscription'
      });
    }
  }
};
